import httpClient from '../utils/axios'
import {
    handleServiceResponse,
    handleServiceError,
} from '../utils/serviceResponseHelper'

const reviewDocument = async ({ documentGuid, contentHtml }) => {
    return httpClient
        .put(`${window.config.DOCUMENT_API_URL}/v1/document/review`, {
            documentGuid: documentGuid,
            contentHtml,
        })
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const completeDocument = async ({
    documentGuid,
    contentHtml,
    caseId,
    templateId,
    eventSetupId,
    workflowComponentId,
    workflowVersion,
    workflowTrackingComponentId,
    isAuditTrailDocumentFixFlagEnabled_68802 = false,
}) => {
    const parsedCaseId = parseInt(caseId)
    const parsedTemplateId = parseInt(templateId)
    const parseEventSetupId = parseInt(eventSetupId)
    const parseWorkflowComponentId = parseInt(workflowComponentId)
    const parsedWorkflowVersion = parseInt(workflowVersion)
    const parsedWorkflowTrackingComponentId = parseInt(workflowTrackingComponentId)

    return httpClient
        .put(`${window.config.DOCUMENT_API_URL}/v1/document/complete`, {
            documentGuid: documentGuid,
            contentHtml,
            caseId: isNaN(parsedCaseId) ? 0 : parsedCaseId,
            eventSetupId: isNaN(parseEventSetupId) ? null : parseEventSetupId,
            workflowComponentId: isNaN(parseWorkflowComponentId)
                ? null
                : parseWorkflowComponentId,
            workflowVersion: parsedWorkflowVersion,
        })
        .then(
            response => {
                const patchUrl = `${window.config.WORKFLOW_TRACKING_API_URL}/api/caseTrackingRecord/${caseId}/document/${documentGuid}`

                if (isAuditTrailDocumentFixFlagEnabled_68802) {
                    if (
                        !isNaN(parsedWorkflowTrackingComponentId) &&
                        !isNaN(parsedTemplateId)
                    ) {
                        httpClient.patch(patchUrl, {
                            TemplateId: parsedTemplateId,
                            EventSetupId: isNaN(parseEventSetupId)
                                ? null
                                : parseEventSetupId,
                            WorkflowComponentId: isNaN(parseWorkflowComponentId)
                                ? null
                                : parseWorkflowComponentId,
                            WorkflowVersion: isNaN(parsedWorkflowVersion)
                                ? null
                                : parsedWorkflowVersion,
                            WorkflowTrackingComponentId: parsedWorkflowTrackingComponentId,
                        })
                    }
                } else {
                    httpClient.patch(patchUrl, {
                        WorkflowTrackingComponentId: workflowTrackingComponentId,
                    })
                }
                return handleServiceResponse(response)
            },
            error => handleServiceError(error)
        )
}

const saveDocument = async ({
    documentGuid,
    contentHtml,
    status,
    caseId,
    templateId,
    eventSetupId,
    workflowComponentId,
    inReviewWithChanges,
    workflowVersion,
    workflowTrackingComponentId,
    isAuditTrailDocumentFixFlagEnabled_68802 = false,
}) => {
    const parsedCaseId = parseInt(caseId)
    const parsedTemplateId = parseInt(templateId)
    const parseEventSetupId = parseInt(eventSetupId)
    const parseWorkflowComponentId = parseInt(workflowComponentId)
    const parsedWorkflowVersion = parseInt(workflowVersion)
    const parsedWorkflowTrackingComponentId = parseInt(workflowTrackingComponentId)

    return httpClient
        .put(`${window.config.DOCUMENT_API_URL}/v1/document/update`, {
            documentGuid: documentGuid,
            contentHtml,
            currentStatus: status,
            caseId: isNaN(parsedCaseId) ? 0 : parsedCaseId,
            eventSetupId: isNaN(parseEventSetupId) ? null : parseEventSetupId,
            workflowComponentId: isNaN(parseWorkflowComponentId)
                ? null
                : parseWorkflowComponentId,
            inReviewWithChanges,
            workflowVersion: parsedWorkflowVersion,
        })
        .then(
            response => {
                const patchUrl = `${window.config.WORKFLOW_TRACKING_API_URL}/api/caseTrackingRecord/${caseId}/document/${documentGuid}`

                if (isAuditTrailDocumentFixFlagEnabled_68802) {
                    if (
                        !isNaN(parsedWorkflowTrackingComponentId) &&
                        !isNaN(parsedTemplateId)
                    ) {
                        httpClient.patch(patchUrl, {
                            TemplateId: parsedTemplateId,
                            EventSetupId: isNaN(parseEventSetupId)
                                ? null
                                : parseEventSetupId,
                            WorkflowComponentId: isNaN(parseWorkflowComponentId)
                                ? null
                                : parseWorkflowComponentId,
                            WorkflowVersion: isNaN(parsedWorkflowVersion)
                                ? null
                                : parsedWorkflowVersion,
                            WorkflowTrackingComponentId: parsedWorkflowTrackingComponentId,
                        })
                    }
                } else {
                    httpClient.patch(patchUrl, {
                        WorkflowTrackingComponentId: workflowTrackingComponentId,
                    })
                }
                return handleServiceResponse(response)
            },
            error => handleServiceError(error)
        )
}

const endReviewDocument = async ({ documentGuid, contentHtml }) => {
    return httpClient
        .put(`${window.config.DOCUMENT_API_URL}/v1/document/endreview`, {
            documentGuid: documentGuid,
            contentHtml,
        })
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const getLastEntrySendToManager = async documentGuid => {
    return httpClient
        .get(
            `${window.config.DOCUMENT_API_URL}/v1/document/GetLastEntrySendToManager?documentGuid=${documentGuid}`
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const createCommunicationViaSendToManager = async (caseId, model) => {
    return await httpClient
        .post(
            `${window.config.CASE_API_URL}/api/casecommunications/createCommunicationViaSendToManager/${caseId}/`,
            model
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const checkDocDirectCode = async code => {
    return httpClient
        .post(
            `${window.config.DOCUMENT_API_URL}/v1/document/checkDocDirectCode`,
            {
                code: code,
            }
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const createDocument = async ({
    documentTemplateId,
    documentGuid,
    caseId,
    fromAddressUserId,
    workflowTrackingRecordId,
}) => {
    const parsedDocumentTemplateId = parseInt(documentTemplateId)
    const parsedCaseId = parseInt(caseId)
    return httpClient
        .post(`${window.config.DOCUMENT_API_URL}/v1/document/create`, {
            documentTemplateId: isNaN(parsedDocumentTemplateId)
                ? 0
                : parsedDocumentTemplateId,
            caseId: isNaN(parsedCaseId) ? 0 : parsedCaseId,
            documentGuid: documentGuid,
            fromAddressUserId: fromAddressUserId,
            workflowTrackingRecordId:
                workflowTrackingRecordId != null
                    ? parseInt(workflowTrackingRecordId)
                    : null,
        })
        .then(
            response => {
                return handleServiceResponse(response)
            },
            error => handleServiceError(error)
        )
}

const continueDocument = async ({ existingDocumentGuid }) => {
    return httpClient
        .get(
            `${window.config.DOCUMENT_API_URL}/v1/document/continue?existingDocumentGuid=${existingDocumentGuid}`
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const getPdf = async documentGuid => {
    return httpClient
        .get(
            `${window.config.DOCUMENT_API_URL}/v1/pdf/GetPdf?documentGuid=${documentGuid}`
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const getPdfPreview = async ({ documentGuid, documentHtml }) => {
    return httpClient
        .post(`${window.config.DOCUMENT_API_URL}/v1/pdf/GetPdfPreview`, {
            documentGuid: documentGuid,
            documentHtml: documentHtml,
        })
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

const getPdfPreviewWithCustomHeaders = async ({
    documentHtml,
    headerHtml,
    footerHtml,
}) => {
    return httpClient
        .post(
            `${window.config.DOCUMENT_API_URL}/v1/pdf/GetPdfPreviewWithCustomHeaders`,
            {
                documentHtml: documentHtml,
                headerHtml: headerHtml,
                footerHtml: footerHtml,
            }
        )
        .then(
            response => handleServiceResponse(response),
            error => handleServiceError(error)
        )
}

export default {
    reviewDocument,
    completeDocument,
    saveDocument,
    createDocument,
    continueDocument,
    endReviewDocument,
    getPdfPreview,
    getPdfPreviewWithCustomHeaders,
    checkDocDirectCode,
    createCommunicationViaSendToManager,
    getLastEntrySendToManager,
    getPdf,
}
